import { PIPELINE_CATEGORY } from "../../../theme/tokens";

// Official Hugging Face task groups, used for consistent pipeline badge colors.
const MULTIMODAL_TAGS = new Set([
  "audio-text-to-text",
  "image-text-to-text",
  "image-text-to-image",
  "image-text-to-video",
  "visual-question-answering",
  "document-question-answering",
  "video-text-to-text",
  "visual-document-retrieval",
  "any-to-any",
]);

const VISION_TAGS = new Set([
  "depth-estimation",
  "image-classification",
  "object-detection",
  "image-segmentation",
  "text-to-image",
  "image-to-text",
  "image-to-image",
  "image-to-video",
  "unconditional-image-generation",
  "video-classification",
  "text-to-video",
  "zero-shot-image-classification",
  "mask-generation",
  "zero-shot-object-detection",
  "text-to-3d",
  "image-to-3d",
  "image-feature-extraction",
  "keypoint-detection",
  "video-to-video",
]);

const NLP_TAGS = new Set([
  "text-classification",
  "token-classification",
  "table-question-answering",
  "question-answering",
  "zero-shot-classification",
  "translation",
  "summarization",
  "feature-extraction",
  "text-generation",
  "fill-mask",
  "sentence-similarity",
  "text-ranking",
  // Older/alternate pipeline ids still seen in model metadata.
  "text2text-generation",
  "conversational",
]);

const AUDIO_TAGS = new Set([
  "text-to-speech",
  "text-to-audio",
  "automatic-speech-recognition",
  "audio-to-audio",
  "audio-classification",
  "voice-activity-detection",
]);

const TABULAR_TAGS = new Set([
  "tabular-classification",
  "tabular-regression",
  "time-series-forecasting",
]);

const REINFORCEMENT_LEARNING_TAGS = new Set([
  "reinforcement-learning",
  "robotics",
]);

const OTHER_TAGS = new Set(["graph-machine-learning", "graph-ml"]);

export function getPipelineCategory(pipelineTag) {
  const tag = String(pipelineTag || "").toLowerCase();
  if (!tag) return null;
  if (MULTIMODAL_TAGS.has(tag)) return "multimodal";
  if (VISION_TAGS.has(tag)) return "vision";
  if (NLP_TAGS.has(tag)) return "nlp";
  if (AUDIO_TAGS.has(tag)) return "audio";
  if (TABULAR_TAGS.has(tag)) return "tabular";
  if (REINFORCEMENT_LEARNING_TAGS.has(tag)) return "reinforcementLearning";
  if (OTHER_TAGS.has(tag)) return "other";

  if (/audio|speech|voice/.test(tag)) return "audio";
  if (/image|video|vision|segmentation|detection|depth/.test(tag)) {
    return "vision";
  }
  if (/tabular|time-series/.test(tag)) return "tabular";
  if (/reinforcement|robot/.test(tag)) return "reinforcementLearning";
  if (/text|token|translat|summar|sentence|ranking|mask/.test(tag)) {
    return "nlp";
  }
  return "other";
}

export function getPipelineColor(pipelineTag) {
  const category = getPipelineCategory(pipelineTag);
  return category ? PIPELINE_CATEGORY[category] : null;
}
